const region = "us-east-1";
const origin = window.location.origin;

const stating = {
  appSettingsData: {
    // generate a file format limit of video file
    autoRefreshFrequency: 10000,
    allowedDomain: ["williamslea.com", "post.williamslea.co.uk"],
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: "us-east-1",
      userPoolId: "us-east-1_EZKSZPly9",
      userPoolWebClientId: "im4732c1bdj9t3e8c25ab2dl",
    },
    oauth: {
      domain: "wl-idp-stg-web.auth.us-east-1.amazoncognito.com",
      redirectSignIn: `${origin}/auth`,
      redirectSignOut: `${origin}/auth`,
      responseType: "code",
      scope: ["openid", "profile", "email"],
    },
    API: {
      endpoints: [
        {
          name: "Transcribe",
          endpoint: "https://api.stg.transcribe.wl-engage.com",
          region: region,
        },
      ],
    },
  },
};
// type statingType = typeof stating

export type StatingType = typeof stating;
export default stating;
